import script from "./AddEmployerForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddEmployerForm.vue?vue&type=script&setup=true&lang=ts"

import "./AddEmployerForm.vue?vue&type=style&index=0&id=4aa0bac4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aa0bac4"]])

export default __exports__